/**
 * Navigation configuration for ClawFarm platform
 */

import { NavigationItem, Role } from '@/types/vertical';

export const NAVIGATION_CONFIG: NavigationItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    href: '/dashboard',
    roles: [Role.ADMIN, Role.OWNER, Role.MEMBER, Role.AGENT_MANAGER, Role.AGENT_USER],
  },
  {
    id: 'agents',
    label: 'Agents',
    icon: 'Bot',
    href: '/agents',
    roles: [Role.ADMIN, Role.OWNER, Role.MEMBER, Role.AGENT_MANAGER, Role.AGENT_USER],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    href: '/settings',
    roles: [Role.ADMIN, Role.OWNER, Role.MEMBER, Role.AGENT_MANAGER, Role.AGENT_USER, Role.BILLING_CONTACT, Role.VIEWER],
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: 'Shield',
    href: '/admin',
    roles: [Role.PLATFORM_ADMIN],
    position: 'user-menu',
  },
];

/**
 * Get navigation items filtered by role
 */
export function getNavigationForRole(role: Role): NavigationItem[] {
  return NAVIGATION_CONFIG.filter(item => item.roles.includes(role));
}

/**
 * Get navigation items filtered by vertical
 */
export function getNavigationForVertical(verticalId: string): NavigationItem[] {
  return NAVIGATION_CONFIG.filter(item => {
    // Include items without vertical restriction or items for this vertical
    return !item.vertical || item.vertical === verticalId;
  });
}

/**
 * Get navigation items with terminology applied
 */
export function getNavigationWithTerminology(
  items: NavigationItem[],
  terminology: Record<string, string>
): NavigationItem[] {
  return items.map(item => {
    const newItem = { ...item };
    // Replace terminology placeholders in labels
    for (const [key, value] of Object.entries(terminology)) {
      newItem.label = newItem.label.replace(
        new RegExp(`\\b${key}\\b`, 'gi'),
        value
      );
    }
    return newItem;
  });
}

// Re-export NavigationItem type for convenience
export type { NavigationItem };
